<template>
  <div class="container">
    <h3 v-if="user.email">User: {{ user.email }}</h3>
    <user-card :user="user" />
    <events-card />
    <teams-card />
    <playgrounds-card
      :playgrounds="userPlaygrounds"
      :loading="loading.userPlaygrounds"
      title="User Playgrounds"
      @refresh="refreshPlaygrounds"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserCard from "./UserCard";
import TeamsCard from "./TeamMembershipsCard";
import EventsCard from "./EventsCard";
import PlaygroundsCard from "../PlaygroundView/PlaygroundsCard";

export default {
  components: {
    UserCard,
    TeamsCard,
    EventsCard,
    PlaygroundsCard,
  },
  created() {
    this.fetchData();
  },
  computed: mapGetters(["user", "userPlaygrounds", "loading"]),
  methods: {
    ...mapActions(["getUser", "getTeamMemberships", "getUserEvents", "getUserPlaygrounds"]),
    async fetchData() {
      const { query: id } = this.$route.params;
      try {
        this.getUser(id);
        this.getTeamMemberships({ parent: "users", parentId: id });
        this.getUserEvents({ id });
        this.getUserPlaygrounds(id);
      } catch (e) {
        this.$notify.error({
          title: "Couldn't fetch all user info :(",
        });
      }
    },
    refreshPlaygrounds() {
      const { query: id } = this.$route.params;
      this.getUserPlaygrounds(id);
    },
  },
  watch: {
    "$route.params"() {
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.container > * + * {
  margin-top: 10px;
}
</style>
